export default __webpack_public_path__ + "static/media/empty-folder.e209de7f.svg";